// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__JgcDn","itemTitle":"ClientEmergencyInfo_itemTitle__fCBcS","itemText":"ClientEmergencyInfo_itemText__fLhly"};